import useTestId from '@ori/testid-generator';
import bemCssModules from 'bem-css-modules';
import { observer } from 'mobx-react-lite';
import type { VFC } from 'react';
import { useEffect, useState } from 'react';

import CategoryButtonListModuleCss from './CategoryButtonList.module.css';
import { CategoryButtonItem } from '~/components/CategoryButtonItem/CategoryButtonItem';
import { Loading } from '~/components/Loading/Loading';
import { useCategoryStore } from '~/stores';

const block = bemCssModules(CategoryButtonListModuleCss);

export const CategoryButtonList: VFC = observer(() => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { categoryCollection, loadCategoryCollection } = useCategoryStore();

  useEffect(() => {
    (async () => {
      await loadCategoryCollection();
      setIsLoaded(true);
    })();
  }, [loadCategoryCollection]);

  if (!isLoaded) {
    return <Loading />;
  }
  const { getTestId } = useTestId();

  return (
    <div
      className={block()}
      data-testid={getTestId('category-links-wrapper')}
    >
      {categoryCollection.map((item) => (
        <CategoryButtonItem
          key={item.Name}
          {...item}
        />
      ))}
    </div>
  );
});
